import axios from 'axios';
import { OCTOPUS_BASE_URL } from '.';

export const getInvoiceTransactions = (invoiceId: string) => {
    const url = `${OCTOPUS_BASE_URL}/invoices/${invoiceId}/transactions`;
    const response = axios.get(url);
    return response;
};

export const addMRRTransaction = (invoiceId: string, payload: any) => {
    const url = `${OCTOPUS_BASE_URL}/invoices/${invoiceId}/mrr-transactions`;
    const response = axios.post(url, payload);
    return response;
};

export const addAdjustmentTransactions = (transactionID: string, payload: { amount: number }) => {
    const url = `${OCTOPUS_BASE_URL}/invoice-transactions/${transactionID}/adjustment-transaction`;
    return axios.post(url, payload);
};

export const revertAdjustmentTransaction = (transactionID: string) => axios.delete(
    `${OCTOPUS_BASE_URL}/invoice-transactions/${transactionID}/adjustment-revert`,
);
